import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { usePage } from "@inertiajs/react";
import { Toaster } from "@Components/Toaster";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ErrorBoundaryFallback } from "@Components/ErrorBoundaryFallback";

const queryClient = new QueryClient();

export function AppLayout({ children }) {
    const toaster = usePage().props.toaster;

    return (
        <StrictMode>
            <Sentry.ErrorBoundary
                fallback={ErrorBoundaryFallback}
                beforeCapture={(scope) => {
                    scope.setTag("location", "AppLayout");
                }}
                showDialog
            >
                <Toaster toaster={toaster} />
                <QueryClientProvider client={queryClient}>
                    {children}
                </QueryClientProvider>
            </Sentry.ErrorBoundary>
        </StrictMode>
    );
}
